import React from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Explore() {
  const history = useHistory();

  return (
    <div className="explore-page">
      <Header Title="Explore" />
      <div className="explore-buttons">
        <div className="e-food">
          <button
            type="button"
            data-testid="explore-foods"
            className="explore-foods-btn"
            onClick={ () => history.push('/explore/foods') }
          >
            Foods
          </button>
        </div>
        <div className="e-drink">
          <button
            type="button"
            data-testid="explore-drinks"
            className="explore-drinks-btn"
            onClick={ () => history.push('/explore/drinks') }
          >
            Drinks
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Explore;
